import { combineReducers } from "redux";

import appReducer from "./reducers";
import referenceReducer from "./reducers/reducer_reference";
import caseSearchReducer from "../../components/Cases/CasesSearch/reducer";
import pwdCaseSearchReducer from "../../components/PWDCasesSearch/reducer";
import networkInvitationReducer from "../../components/NetworkContainer/reducers/reducer_sendInvitation";
import deleteGroupReducer from "../../components/NetworkContainer/reducers/reducer_deleteGroup";
import createGroupReducer from "../../components/NetworkContainer/reducers/reducer_createGroup";
import errorReducerPlugin from "../../components/Form/reducer/errorReducerPlugin";
import pwdCaseSelectedReducer from "../../components/Form/EntityForm/reducer_pwdSelected";
import certCaseSelectedReducer from "../../components/PWDCasesSearch/CERTCasesSearch/reducer_certSelected";

import { reducer as notificationsReducer } from "reapop";

import { reducer as formReducer } from "redux-form";

const rootReducer = () =>
  combineReducers({
    appReducer,
    referenceReducer,
    caseSearchReducer,
    pwdCaseSearchReducer,
    networkInvitationReducer,
    deleteGroupReducer,
    createGroupReducer,
    form: formReducer.plugin(errorReducerPlugin),
    notifications: notificationsReducer(),
    pwdCaseSelectedReducer,
    certCaseSelectedReducer,
  });

export default rootReducer;
